<template>
    <div class="header">
      <div class="row">
        <div class="col-12">
          <h4 class="login-title">{{ $t('Reset') }}</h4>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t('New password') }}</label>
            <input type="password" v-model="reset.newPass" class="form-control">
          </div>
          <div class="form-group">
            <label>{{ $t('Confirm new password') }}</label>
            <input type="password" v-model="reset.confirmNewPass" class="form-control">
          </div>
          <div class="form-group text-danger" v-if="reset.error">{{ reset.error }}</div>
        </div>
        <div class="col-12">
          <button @click="resetPassword" class="btn primary-bg">
            <i class="fa fa-spinner fa-spin" v-if="reset.showSpinner"></i>
            <span v-else>{{ $t('Reset password') }}</span>
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import URL from "../../assets/js/URL-Parser/js/URLParser";
import register from './Register.vue'
import AutoComplete from '../../helpers/maps/AutoComplete'
import Geocode from '../../helpers/maps/Geocode'
import debounce from 'debounce'

export default {
    name: "reset",
    data() {
        return {
            reset: {
                confirmNewPass: '',
                newPass: '',
                token: null,
                showSpinner: false,
                error: false,
                errors: {
                    length: this.$t('Password length should be at least 6 characters'),
                    mismatch: this.$t('Provided passwords do not match'),
                    unvalidToken: this.$t('Invalid token'),
                }
            },
            e: {
                error: false,
                errors: {
                    unvalidEmail: this.$t('The provided Email does not exists')
                }
            },
            r
        };
    },
    computed: {
        ...mapState({
            trainerId: state => state.trainerVisit,
            trainerList: state => state.frontPage.trainerSearch.trainerList
        })
    },
    methods: {
        toggleLogin() {

        },
        resetPassword() {
            let vm = this;
            this.reset.token = URL.get('passwordToken');
            this.reset.showSpinner = true;
            if (this.reset.newPass.length < 6 || this.reset.confirmNewPass.length < 6) {
                this.reset.error = this.reset.errors.length;
                this.reset.showSpinner = false;
                return;
            }
            if (this.reset.newPass != this.reset.confirmNewPass) {
                this.reset.error = this.reset.errors.mismatch;
                this.reset.showSpinner = false;
                return;
            }

            axios.post(process.env.api_hostname + '/resetPassword',
                {
                    password: vm.reset.confirmNewPass,
                    token: vm.reset.token
                }).then(response => {
                    if (response.data.error == 'unvalidToken') {
                        vm.reset.error = vm.reset.errors.unvalidToken;
                        setTimeout(() => {
                            $('#resetPassModal').modal('hide');
                            this.$router.push('/dashboard');
                        }, 1500);
                    }
                    if (response.data.statusCode == 200) {
                        this.$notify({
                            group: "foo",
                            title: this.$t("Message"),
                            text: this.$t("Password successfully changed")
                        });
                        $('#resetPassModal').modal('hide');
                        this.$router.push('/dashboard');
                        setTimeout(() => {
                            $('#loginModal').modal('show');
                        }, 500);
                    }
                    vm.reset.showSpinner = false;
                    vm.reset.newPass = '';
                    vm.reset.token = '';
                    vm.reset.confirmNewPass = '';
                });
        }
    }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/frontpage/Reset.vue